const OperatorConfig = {
    list: ["equals", "less_than", "less_than_or_equal", "greater_than", "greater_than_or_equal","contains", "not_contains", 'has_selected'],
    map_by_question_type: {
            Number: ['equals', 'less_than', 'less_than_or_equal', 'greater_than', 'greater_than_or_equal'],
            Rating: ['equals', 'less_than', 'less_than_or_equal', 'greater_than', 'greater_than_or_equal'],                    
            Checkbox: ['contains', 'not_contains', 'has_selected'],
            Radio: ['contains', 'not_contains', 'has_selected']
    },
    condition_operator_tooltip: {
        contains: "A rule or condition that contains one input or a combination of inputs should be written using square brackets with each input written in numerical form separated by a comma.<br>Example would be:<br>QID1 [1,2,3,5].  Thus, if QID 1 = 1 or 2 or 3 or 5 or any combination of those inputs, the rule or condition will be considered true.",
        not_contains: "A rule or condition that does not contain set of specified inputs should be written using square brackets with each input written in numerical form separated by a comma.<br>Example would be:<br>QID1 [1,2,3,5].  Thus, if QID 1 != 1 and !=2 and !=3  and !=5, means when NONE of specified inputs selected the rule or condition will be considered true.",
        equals: "Feasible when selected `Referenced Source` is Question",
        less_than: "Feasible when selected `Referenced Source` is Question",
        less_than_or_equal: "Feasible when selected `Referenced Source` is Question",
        greater_than: "Feasible when selected `Referenced Source` is Question",
        greater_than_or_equal: "Feasible when selected `Referenced Source` is Question",
        has_selected: "Feasible when selected `Referenced Source` is Question of Radio or Select type. Alternate way to allows user explicitly select ref. question input. Mainly exist for backward compitability usage."        
    },
    
    check_logic_gate: {
        test: function(){
            console.log("test");
        },
        equals: function(rule, reference, group_id){
            return reference.value[group_id]===rule.equals;
        },
        greater_than: function(rule, reference, group_id){
            return reference.value[group_id]>rule.greater_than;
        },
        greater_than_or_equal: function(rule, reference, group_id){
            return this.greater_than(rule, reference, group_id) || this.equals(rule, reference, group_id);
        },
        less_than: function(rule, reference, group_id){
            return reference.value[group_id]<rule.less_than;
        },
        less_than_or_equal: function(rule, reference, group_id){
            return this.less_than(rule, reference, group_id) || this.equals(rule, reference, group_id); 
        },
        not_contains: function(rule, reference, details, group_id){
            let valueSet = reference.value[group_id];
            try{
                rule.not_contains = JSON.parse(rule.not_contains);
            }catch{

            }

            let filteredArray = [];
            if (typeof valueSet=="object" && valueSet.length && rule.not_contains.length){
                filteredArray = rule.not_contains.filter(value => valueSet.includes(value));
            }
            else {
                return false;
            }
            
            return filteredArray.length!==rule.not_contains.length;
        },
        contains: function(rule, reference, details, group_id){
            let value = reference.value[group_id];
            let found = false;
            try{
                rule.contains = JSON.parse(rule.contains);
            }catch{

            }
            
            switch(typeof rule.contains){
                case"string":case"number"://Contain rule is a string or number

                    switch(typeof value){
                        case"string":case"number": //reference value is string or number
                            if(rule.contains == value){
                                found = true;
                                details = value;
                                break;
                            }
                        break;

                        case"object": //reference value is an array                                                         
                            for(let checked_index in value){
                                var checked_value = value[rule.input_id ? rule.input_id : checked_index];
                                if(rule.contains == checked_value){
                                    found = true;
                                    details = value;
                                }
                            }
                        break;
                    }

                break;

                case"object"://Contains rule is an array

                    switch(typeof value){
                        case"string":case"number":
                            for(let i in rule.contains){
                                var string = rule.contains[i];
                                if(string == value){
                                    found = true;
                                    details = value;
                                    break;
                                }
                            }
                        break;

                        case"object":
                            for(let i in rule.contains){
                                var string = rule.contains[i];
                                for(let checked_index in value){
                                    var checked_value = value[checked_index];
                                    if(string == checked_value){
                                        found = true;
                                        details = value;
                                        break;
                                    }
                                }
                            }
                        break;
                    }

                break;
            } 
            
            return found;
        }
    }
};

export default OperatorConfig 